/** @format */

import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { getHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import CustomModal from "../../core/modal";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import OemNameFilters from "./oem-names-filters";
import { INDUSTRY } from "../oems/helper";
import Select from "react-select";

const OemNames = () => {
  const [addParts, setAddParts] = useState("");
  const [description, setDescription] = useState("");
  const [nameId, setNameId] = useState("");
  const [parts, setParts] = useState([]);
  const [industry, setIndustry] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData();
    }
  }, []);

  const loadData = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          setParts(response);
        }
      })
      .catch((err) => console.error(err));
  };

  const addPartFormHandler = () => {
    setAddParts("ADD");
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };

  //Add New Part
  const formSubmitHandler = () => {
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, {
      name: description,
      industry: industry,
    })
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData();
          setDescription("");
          setIndustry("");
          setAddParts(false);
        }
      })
      .catch((err) => console.error(err));
  };

  const onEditSubmitHandler = () => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.OEM_NAMES}/${nameId}`, {
      name: description,
      industry: industry,
    })
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData();
          setDescription("");
          setIndustry("");
          setAddParts(false);
        }
      })
      .catch((err) => console.error(err));
  };
  const addIndustryHandler = (event) => {
    setIndustry(event.label);
  };
  const onEdit = (data) => {
    setAddParts("EDIT");
    setDescription(data.name);
    setNameId(data.id);
    setIndustry(data?.industry);
  };
  return (
    <>
      <div className="page-body">
        <div className="create-con">
          <div>
            <p className="tab-name">Setup</p>
            <p className="section-name">Oems List</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={addPartFormHandler}
          >
            Add OEM
          </CustomButtonComponent>
        </div>

        <div className="si-hide-mobile">
          <CustomTable
            header={getHeaderConfig(loadData, onEdit)}
            data={parts || []}
            filterCom={<OemNameFilters loadData={loadData} oems={parts} />}
          />
        </div>
        {addParts && (
          <CustomModal
            title={addParts === "ADD" ? "New OEM name " : "Edit OEM name"}
            onClose={() => {
              setAddParts("");
              setIndustry("");
            }}
          >
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                fullWidth
                id="description"
                label="Name"
                size="small"
                sx={{ m: 1 }}
                rows={4}
                onChange={addDescriptionHandler}
                value={description}
              />
              <Box sx={{ ml: 1, mb: 5 }}>
                <p style={{ margin: "0px", marginBottom: "8px" }}>Domain</p>
                <Select
                  value={industry}
                  classNamePrefix="si-select"
                  options={INDUSTRY}
                  onChange={addIndustryHandler}
                  placeholder={industry !== "" ? industry : "Domain"}
                />
              </Box>

              <Stack
                direction="row"
                spacing={2}
                sx={{ m: 1, justifyContent: "flex-end" }}
              >
                <CustomButtonComponent
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setAddParts("");
                    setIndustry("");
                  }}
                >
                  Cancel
                </CustomButtonComponent>
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={!description || !industry}
                  onClick={
                    addParts === "ADD" ? formSubmitHandler : onEditSubmitHandler
                  }
                >
                  Save
                </CustomButtonComponent>
              </Stack>
            </Box>
          </CustomModal>
        )}
      </div>

      {/* <div className="part-container">
        <div className="button-div">
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={{
              borderRadius: 120,
            }}
            onClick={addPartFormHandler}
          >
            Add OEM
          </Button>
        </div>
        <SiTable
          header={getHeaderConfig(loadData, onEdit)}
          title="OEM names"
          data={parts || []}
        ></SiTable>
      </div>
      {addParts && (
        <CustomModal
          title={addParts === "ADD" ? "New OEM name " : "Edit OEM name"}
          onClose={() => setAddParts("")}
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="description"
              label="Name"
              size="small"
              sx={{ m: 1 }}
              rows={4}
              onChange={addDescriptionHandler}
              value={description}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{ m: 1, justifyContent: "space-between" }}
            >
              <Button
                variant="contained"
                color="inherit"
                sx={{ borderRadius: 160 }}
                onClick={() => {
                  setAddParts("");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ borderRadius: 160 }}
                endIcon={<ArrowForward />}
                disabled={!description}
                onClick={
                  addParts === "ADD" ? formSubmitHandler : onEditSubmitHandler
                }
              >
                Save
              </Button>
            </Stack>
          </Box>
        </CustomModal>
      )} */}
    </>
  );
};

export default OemNames;
